import { useEffect, useState, useRef } from "react"
import { useSelector } from "react-redux"
import Axios from 'axios'
import Cookies from "universal-cookie"
import uuid from 'react-uuid'
import Container from "../components-layout/Container"
import Layout from "../Layout"
import WarningModal from "../components-modals/WarningModal"
import GridItemsProductos from "./components/GridItemsProductos"
import Pagination from "../components-contabilidad-analisis/Pagination"
import { CheckCircleIcon, ExclamationCircleIcon } from "@heroicons/react/24/outline"
import SubmitButton from "../c&m/facturacion/SubmitButton"
import Header from "../components-layout/Header"
import { MathSymbolsLogo } from "../components-layout/Logos"
import FormEncabezado from "./components/FormEncabezado"
import GridItemsSeleccionados from "./components/GridItemsSeleccionados"
import { fetchData } from "./functions/Index"

const searchParams = ['IdProducto', 'Descripcion', 'Descripcion_Corta', 'Imagen', 'IdTipo', 'Tipo', 'IdCategoria', 'Categoria', 'IdProveedor', 'Proveedor', 'Costo', 'Precio', 'Existencia', 'Inventario', 'FacRapida', 'Pedido', 'Activo']

const ProveedoresIndex = () => {

    const user = useSelector(state => state.auth.user) 
    const userObj = JSON.parse(user)

    const cookies = new Cookies()
    const urlInvoiceApi = cookies.get('__urlInvoiceApi')
    const url = urlInvoiceApi + '/utils/busquedas'
    const urlPost = urlInvoiceApi + '/inventario/ingresos_ajustes'
    const headers = useSelector(state => state.url.headersAPI)

    //Fetch inicial de productos
    const [loading, setLoading] = useState(true)
    const [rawData, setRawData] = useState([])
    const bodegas = useSelector(state => state.auth.bodegas)
    const primerIdBodega = bodegas[0].IdBodega

    const [envio, setenvio] = useState({})
    const [detalleEnvio, setDetalleEnvio] = useState({
        Detalle: {

        }
    })

    useEffect(() => {
        fetchData({Axios, url, headers, setRawData, setLoading, primerIdBodega})
    }, [])

    //Busqueda 
    const [filterData, setFilter] = useState([])
    useEffect(() => { setFilter(rawData) }, [rawData])

    const handleQuery = (values) => {
        doSearch(values.query.trim())
        setCurrentPage(1)
    }

    const doSearch = (query) => {
        if (query === null) {
            setFilter(rawData)
        } else {
            setFilter(rawData.filter((x) => {
                return searchParams.some((y) => {
                    return x[y]?.toString().toLowerCase().indexOf(query.toLowerCase()) > -1
                })
            }))
        }
    }
    //Fin busqueda
    const handleIdChange = (e, producto, Idx) => {
        console.log('producto', producto)
        console.log('Idx', Idx)
        console.log('e', e.target)
        let productoParam = producto
        producto.Id = e.target.value
        // hacer el cambi para editar la propiedad Id del curso seleccionado y enviarlo al estado producto
        setProducto([
            ...productos,
            producto
        ])
    }
    //Paginación
    const [currentPage, setCurrentPage] = useState(1)
    const recordsPerPage = 10
    const indexOfLastRecord = currentPage * recordsPerPage
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
    const currentRecords = filterData?.slice(indexOfFirstRecord, indexOfLastRecord)
    const nPages = Math.ceil(filterData?.length / recordsPerPage)
    //Fin paginación
    //Helpers de productos tipo CRUD
    const [productos, setProducto] = useState([])
    const [ajusteListener, setAjusteListener] = useState('') //estado auxiliar para validar existencias vs qty cuando Sel === 'Ajuste' && Ajuste === false
    const [validateStock, setValidateStock] = useState(false)

    const addProduct = (id, producto) => {

        if(producto.Existencia < 1 && validateStock) {
            return setModal({
                msg: 'Producto sin existencias',
                ok: false,
                show: true
            })
        }

        const isDuplicated = productos.findIndex(prod => prod.IdProducto === producto.IdProducto) !== -1 ? true : false

        if(!isDuplicated){
            
            const id = uuid()

            setProducto(curr => [
                ...curr,
                { ...producto, id, qty: 1 } 
            ])
        }
    }

    const updateProducto = (producto, prop = '', payload = '') => {
        
        const { id } = producto

        const indexOfId = productos.findIndex(producto => producto.id === id)

        setProducto(curr => {
            if(prop === 'qty' && payload >= 0){
                if(ajusteListener && payload > curr[indexOfId].Existencia){
                    setModal({
                        msg: 'No puede realizar un ajuste negativo mayor a las existencias del producto',
                        ok: false,
                        show: true,
                    })
                }else{
                    curr[indexOfId][prop] = payload
                }
            }
            return [...curr]
        })

    }

    const cleanProductos = () => {
        setProducto([])
    }

    const delProducto = (producto) => {
        const { id } = producto
        const newProductos = productos.filter(prod => prod.id !== id)
        setProducto(newProductos)
    }

    //Hook auxiliar para realizar submit desde otro componente fuera de formik
    const formRef = useRef()
    const handleClick = () => {
        if(formRef.current){
            formRef.current.handleSubmit()
        }
    }

    //Manejo de errores
    const [modal, setModal] = useState({
        show: false,
        msg: '',
        ok: false,
    })

    useEffect(() => {
      console.log(productos)
    }, [productos])
    


    return(
        <Layout userObj={userObj} activeTab='Proveedores'>    
            <WarningModal
                open={loading ? true : false}
                image={<img src='./img/loader.gif' alt='loading' />}
                opacity='bg-opacity-100'
            />

            <WarningModal
                open={modal.show ? true : false}
                image={
                    modal.ok 
                        ? <CheckCircleIcon className="h-20 w-20 text-green-500 mx-auto"/>
                        : <ExclamationCircleIcon className="h-20 w-20 text-red-500 mx-auto"/>
                }
                title='Aviso'
                subtitle={<span>{modal.msg}</span>}
                opacity='bg-opacity-50'
            >
                <div className="mt-5 sm:mt-6">
                <button
                    onClick={() => {
                        if(modal.ok){
                            window.location.reload()
                        }
                        setModal(curr => ({
                            ...curr, show: false
                        }))
                    }}
                    type="button"
                    className="inline-flex w-full justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
                >
                    Entendido
                </button>
                </div>
            </WarningModal>
      
            <Container height='h-full'>
                <Header
                    title="Proveedores"
                    logo={MathSymbolsLogo}
                />
                <div className="grid grid-cols-1 2xl:grid-cols-2 gap-5 2xl:gap-x-5 2xl:gap-y-0">
                    <div className="order-1 bg-primarioMira shadow-2xl rounded-lg 2xl:rounded-b-none 2xl:rounded-t-lg border-b-0 2xl:border-b border-b-grisMira">
                        <FormEncabezado
                            url={url}
                            urlPost={urlPost}
                            headers={headers}
                            setAjusteListener={setAjusteListener}
                            cleanProductos={cleanProductos}
                            formRef={formRef}
                            productos={productos}
                            setModal={setModal}
                            setRawData={setRawData}
                            setValidateStock={setValidateStock}
                        />
                    </div>
                    <div className="order-2 2xl:order-3 bg-primarioMira shadow-2xl rounded-lg 2xl:rounded-t-none 2xl:rounded-b-lg">
                        <GridItemsProductos
                            data={currentRecords}
                            handleQuery={handleQuery}
                            addProduct={addProduct}
                            label="Lista detallada de productos donde puede consultar y agregar productos al ingreso o ajuste de bodega."
                        >
                        </GridItemsProductos>
                        
                        <Pagination
                            nPages={nPages}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            totalRecords={filterData?.length}
                            indexOfFirstRecord={indexOfFirstRecord}
                            indexOfLastRecord={indexOfLastRecord}
                        />
                    </div>
                    <div className="order-3 2xl:order-2 row-span-2 bg-primarioMira shadow-2xl rounded-lg flex flex-col">
                        <GridItemsSeleccionados
                            productos={productos}
                            delProducto={delProducto}
                            updateProducto={updateProducto}
                            height={'2xl:h-[36rem]'}
                            porUnidad={false}
                            handleIdChange={handleIdChange}
                        >
                        </GridItemsSeleccionados>
                        <SubmitButton
                            label={'Realizar envío'}
                            handleClick={handleClick}
                        />
                    </div>
                </div>
            </Container>
        </Layout>
    )
}

export default ProveedoresIndex